import {Segment} from 'semantic-ui-react';

function AboutUs() {
  return (
    <Segment>
      <h1>درباره ما</h1>
      <p>
        گروه مد مشاور در سال 1396 فعالیت خود را در قالب مشاوره
        آزمون های دستیاری تخصصی و پیش کارورزی شروع کرد.
      </p>
      <p>
        در حال حاضر این گروه با تیمی مجرب متشکل از رتبه های برتر آزمون دستیاری فعالیت خود را ادامه می دهد.
      </p>
      <p>صاحب امتیاز: دکتر میثم شریفی</p>
      <div>
        <p>مشاورین:</p>
        <ul>
          <li> دکتر فرشته مقصودلو</li>
          <li> دکتر مهران خداکرمی</li>
          <li> دکتر مهدی نوری</li>
          <li> دکتر سجاد رضوان</li>
          <li> دکتر هما همتی مقدم</li>
          <li> دکتر حسین گراوند</li>
          <li>دکتر نیلوفر محمدی</li>
        </ul>
      </div>

    </Segment>
  );
}

export default AboutUs;
